import { Icon } from '@aibees/shared/components';
import { classnames, fDate } from '@aibees/shared/utils';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  useTheme,
} from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { PublicationsItemProps as Props } from './types';

export const PublicationsItem = memo(({ className, item, index }: Props) => {
  const theme = useTheme();

  const handleClick = () => {
    window.open(item.url ?? '#', '_blank');
  };

  return (
    <Card
      className={classnames('PublicationsItem', className)}
      sx={SX.root}
      key={index}
      variant="filled"
      color="default"
    >
      <CardContent padding="extra">
        <Box display="flex" flexDirection="column" gap={1}>
          <Typography variant="h6">{item.name}</Typography>

          <Box display="flex" justifyContent="space-between">
            <Box>
              <Typography variant="body4" color="grey.500">
                {item.publisher ? `${item.publisher}, ` : ''}
                {fDate(item.date, 'MMM dd, yyyy')}
              </Typography>
            </Box>

            {item.url && (
              <Box>
                <Button
                  variant="outlined"
                  size="xsmall"
                  color="primary"
                  onClick={handleClick}
                  endIcon={<Icon name="open-in-new" size={12} />}
                >
                  Show publication
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
});

PublicationsItem.displayName = 'PublicationsItem';
